import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, Button } from "react-bootstrap";
import { toDateParseFR } from "../../../utils/datesHeures";
import avi from "../../../assets/extensions/avi.png";
import doc from "../../../assets/extensions/doc.png";
import gif from "../../../assets/extensions/gif.png";
import jpg from "../../../assets/extensions/jpg.png";
import mp4 from "../../../assets/extensions/mp4.png";
import pdf from "../../../assets/extensions/pdf.png";
import png from "../../../assets/extensions/png.png";
import ppt from "../../../assets/extensions/ppt.png";
import svg from "../../../assets/extensions/svg.png";
import xls from "../../../assets/extensions/xls.png";
import xml from "../../../assets/extensions/xml.png";
import zip from "../../../assets/extensions/zip.png";
import folder from "../../../assets/extensions/default.png";

const BlocPublicationsThumbnail = (props) => {
  const { t } = useTranslation();
  const { publicationObject } = props;
  const [illustrationThumbnail, setIllustrationThumbnail] = useState("");
  const extension = publicationObject.URL.substring(publicationObject.URL.lastIndexOf(".") + 1);

  const afficheDatePublication = () => {
    if (publicationObject.datePublication)
      return (
        <div className="datePublicationEmission">
          {t("public.componentPublication.publieeLe")}{" "}
          {toDateParseFR(publicationObject.datePublication)}
        </div>
      );
  };

  const trouveExtension = () => {
    if (publicationObject.cardPic)
      setIllustrationThumbnail(
        process.env.REACT_APP_URL_EXPRESS + "images/publication/small/" + publicationObject.cardPic
      );
    else {
      switch (extension) {
        case "avi":
          setIllustrationThumbnail(avi);
          break;
        case "docx":
        case "doc":
          setIllustrationThumbnail(doc);
          break;
        case "gif":
          setIllustrationThumbnail(gif);
          break;
        case "jpeg":
        case "jpg":
          setIllustrationThumbnail(jpg);
          break;
        case "mp4":
          setIllustrationThumbnail(mp4);
          break;
        case "pdf":
          setIllustrationThumbnail(pdf);
          break;
        case "png":
          setIllustrationThumbnail(png);
          break;
        case "pptx":
        case "ppt":
          setIllustrationThumbnail(ppt);
          break;
        case "svg":
          setIllustrationThumbnail(svg);
          break;
        case "xlsx":
        case "xls":
          setIllustrationThumbnail(xls);
          break;
        case "xml":
          setIllustrationThumbnail(xml);
          break;
        case "zip":
          setIllustrationThumbnail(zip);
          break;
        default:
          setIllustrationThumbnail(folder);
          break;
      }
    }
  };

  useEffect(() => {
    trouveExtension();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card className="d-flex flex-column justify-content-between align-items-center componentThumbnail m-2 ">
      <span className="overflowInContent">
        <a href={publicationObject.URL} target="_blank" rel="noreferrer">
          <div className="text-center">
            <Card.Img
              className={
                publicationObject.cardPic
                  ? "ps-4 pe-4 pt-1 m-auto"
                  : "logoExtension  p-1 ps-4 pe-4  m-auto"
              }
              variant="top"
              src={illustrationThumbnail}
            />
          </div>
          <Card.Body>
            <Card.Title>
              {publicationObject.nom}
              <div className="fw-normal p-1"> {publicationObject.description}</div>
              {afficheDatePublication()}
            </Card.Title>
          </Card.Body>
        </a>
      </span>
      <Button href={publicationObject.URL} target="_blank" rel="noreferrer" className="buttonCard">
        {t("public.boutons.je_m_interesse")}
      </Button>
    </Card>
  );
};

export default BlocPublicationsThumbnail;
